export const downloadFile = (filename: string, href: string): void => {
  const link = document.createElement('a');
  link.download = filename;
  link.href = href;
  link.click();
  link.remove();
};

